import type { ButtonProps } from '@chakra-ui/react';
import { Image } from '@chakra-ui/react';
import { ButtonWithAuthentication } from '@ui/components/ButtonWithAuthentication';
import { useCreateAgentModal } from '@ui/components/CreateAgentModal/useCreateAgentModal';

export const NewAgentButton = (props: ButtonProps) => {
  return (
    <ButtonWithAuthentication
      minW={{
        desktop: '200px',
      }}
      onClick={() => useCreateAgentModal.getState().openModal()}
      position="relative"
      overwriteContent={false}
      {...props}
    >
      + New agent
      <Image
        src="/images/hand-pointer.svg"
        w="42px"
        h="45px"
        position="absolute"
        right="0"
        bottom="-20px"
        alt="hand"
      />
    </ButtonWithAuthentication>
  );
};
